<template>
    <el-card shadow="hover">
        <label slot="header">JUpload上传组件</label>
        <el-divider content-position="left">mode = list列表模式，绑定值返回文件路径字符串（默认以，拼接）,限制仅能上传三个文件</el-divider>
        <span class="j-upload-demo-text">fileStr: {{ fileStr }} </span>
        <j-upload v-model="fileStr" :count-limit="3">
          <span slot="tip-center">提示插槽自带样式，提示插槽自带样式，提示插槽自带样式</span>
        </j-upload>
        <el-divider content-position="left">mode = icon图标模式，绑定值返回文件路径组成的数组, 限制只能上传1MB以下的文件</el-divider>
        <span class="j-upload-demo-text">fileArray: {{ fileArray }} </span>
      <j-upload v-model="fileArray" type="Array" mode="icon" :size-limit="1">
        <span slot="tip-bottom">下方的提示插槽文字</span>
      </j-upload>
        <el-divider content-position="left">mode = card卡片模式，绑定值返回文件路径字符串（默认以，拼接）限制仅能上传三种图片格式</el-divider>
        <span class="j-upload-demo-text">fileArray: {{ fileArray }} </span>
      <j-upload v-model="fileArray" type="Array" mode="card" :mime-type-limit="['image/jpeg', 'image/gif', 'image/png']">
        <span slot="tip-top">上方的提示插槽文字</span>
      </j-upload>
        <el-divider content-position="left">触发按钮插槽，提示容器插槽</el-divider>
        <j-upload v-model="file" >
            <el-button>按钮插槽触发</el-button>
            <div slot="tip-center" style="color: palegreen;font-size: 16px;">中间的提示插槽样式自己定义，icon、card模式下中间插槽不会被应用</div>
        </j-upload>
        <el-divider content-position="left">支持拖拽上传使用</el-divider>
        <j-upload v-model="file" drag style="width: 500px;">
            <span slot="tip">拖拽时提示插槽在内部，拖拽时提示插槽在内部，拖拽时提示插槽在内部</span>
        </j-upload>
        <el-divider content-position="left">使用内部方法触发上传</el-divider>
        <el-link type="primary" @click="refClick">点击触发</el-link>
        <span class="j-upload-demo-text">src: {{ src }} </span>
        <j-upload v-show="false" ref="JuploadRef"
                  @upload-progress="uploadProgress"
                  @upload-complete="uploadComplete"
                  @upload-error="uploadError"
                  need-fully/>
    </el-card>
</template>

<script>
    import JUpload from "./JUpload";
    export default {
        name: "JUploadDemo",
        components: {
            JUpload
        },
        data() {
            return {
                src: '',
                file: '',
                fileStr: '',
                fileArray: []
            }
        },
        methods: {
            refClick () {
                this.$refs.JuploadRef && this.$refs.JuploadRef.UploadTrigger()
            },
            uploadProgress (event, file, fileList) {
                console.log('上传进度中',event, file, fileList)
            },
            uploadComplete (src) {
                console.log('上传完成',src)
                this.src = src
            },
            uploadError (err, file, fileList) {
                console.log('上传出错',err, file, fileList)
            }
        }
    }
</script>

<style>
    .j-upload-demo-text {
        display: block;
        color: #2CA2F2;
    }
</style>
